// Conversión entre los renglones de la API y las líneas que usan los
// componentes compartidos con Nuevo Pedido (que usan "sena" en lugar de
// "entrega_sena" y "tipo: 'envase'" para los envases).

const ID_USO_ENVASE = 367;

export const renglonApiALinea = (renglon) => ({
  id: renglon.id, // id del renglón en la base: identifica a los existentes.
  uuid_pedido: renglon.uuid_pedido,
  producto: renglon.producto,
  cantidad: renglon.cantidad,
  especificaciones: renglon.especificaciones ?? "",
  promo: renglon.promo ?? 0,
  sena: renglon.entrega_sena ?? 0,
  ...(renglon.id_uso === ID_USO_ENVASE ? { tipo: "envase" } : {}),
});

// Campos que se envían al actualizar / crear un renglón (igual que el original).
export const lineaARenglon = (linea, usuario) => ({
  producto: linea.producto,
  cantidad: linea.cantidad,
  especificaciones: linea.especificaciones,
  usuario,
  promo: linea.promo || 0,
  entrega_sena: linea.sena || 0,
});

export const esRenglonExistente = (linea) => linea.id !== undefined && linea.id !== null;
